export const SELLER_DASHBOARD_QUERY = '/seller-dashboard-query';
export const PERSIST_USER = '/login';
export const SURVEYS_QUERY = '/loyalty/survey-seller-office-capability';
export const SALES_GRAPH_QUERY = '/sales-chart/data';
export const AFTER_LOGIN_QUERY =
  '/seller-notice-content-query/after-login-content';
export const PUBLIC_COOKIE = '/login/public';
export const AUTH_LOGOUT = '/login/logout';
export const EXPORT_EXCEL =
  '/seller-product-query/api/v1/templates/product-update-filtered';
export const CHANGE_APPROVAL_STATUS_URL =
  '/endpoint-products/change-approval-status';
export const DELETE_PRODUCTS_URL = '/endpoint-products/delete-bulk';
export const SHIPMENT_TEMPLATES_URL = '/endpoint-shipment/';
export const UPDATE_PRODUCT_SHIPMENT =
  '/endpoint-products/bulk-update-product-shipment';
export const PRODUCT_LIST_SUMMARY = '/endpoint-products/product-list-summary';
export const PRODUCT_UPDATE = '/endpoint-products/simple';
export const SELLER_DASHBOARD_QUERY_CONFIGS = '/seller-dashboard-query/configs';
export const PRODUCT_GROUP_SEARCH =
  '/seller-product-query/api/v1/product-group/search';
export const PRODUCT_IMAGES = '/seller-product-query/api/v1/product-image/{id}';
export const SELLER_CATALOG_SEARCH =
  '/seller-product-query/api/v1/catalog-product/search';
export const OPEN_FOR_SALE = '/endpoint-products/add-from-catalog';
export const ENDPOINT_SHIPMENT_MODAL_CONTROL =
  '/seller-documents/check-approval-statuses';
export const SELLER_STATUS = '/seller-status';
export const PRODUCT_DEAL_NOTIFICATION = '/product-deals/notification';
export const SELLER_SUB_ACCOUNTS = '/seller-sub-accounts';
export const DELETE_SUB_ACCOUNTS = '/seller-sub-accounts/{username}';
export const RESET_PASSWORD_SUB_ACCOUNTS =
  '/seller-sub-accounts/{username}/reset-password';
export const CHANGE_PASSWORD_SUB_ACCOUNTS =
  '/seller-sub-accounts/change-password';
export const PRODUCT_DEALS_MODIFY = '/product-deals/{id}/modify';
export const PRODUCT_DEALS_APPLY = '/product-deals/{id}/apply';
export const PRODUCT_DEALS = '/product-deals';
export const PRODUCT_DEALS_LATEST = '/product-deals/latest';
export const PRODUCT_DEALS_ACCEPTED_COUNT = '/product-deals/count/accepted';
export const PRODUCT_DEALS_REVOKE_SELECTED = '/product-deals/revoke/selected';
export const PRODUCT_DEALS_REVOKE_ALL = '/product-deals/revoke/all';
export const PRODUCT_DEAL_GOTO_PRODUCT_DETAIL =
  '/endpoint-products/product-detail-page-url/{pid}';
export const PRODUCT_DEAL_REJECT_OFFER = '/product-deals/{id}/revoke';
export const UMBRELLA_CAMPAIGNS_LIST = '/umbrella-campaigns';
export const UMBRELLA_CAMPAIGNS_DETAIL = '/umbrella-campaigns/{campaignId}';
export const UMBRELLA_CAMPAIGNS_LEAVE = '/umbrella-campaigns/{campaignId}/leave';
export const UMBRELLA_CAMPAIGNS_JOIN = '/umbrella-campaigns/{campaignId}/join';
export const UMBRELLA_CAMPAIGNS_PRODUCTS = '/umbrella-campaigns/{campaignId}/products';
export const UMBRELLA_CAMPAIGNS_PRODUCTS_ACTIVE_FILTERS = '/umbrella-campaigns/{campaignId}/products/active-filters';
export const UMBRELLA_CAMPAIGNS_NOTICE_STATUS = '/umbrella-campaigns/promotional-notice-status';
export const UMBRELLA_CAMPAIGNS_DOWNLOAD_TEMPLATE = '/umbrella-campaigns/{campaignId}/bulk-products/template/{templateId}/download';
export const UMBRELLA_CAMPAIGNS_CREATE_TEMPLATE = '/umbrella-campaigns/{campaignId}/bulk-products/template';
export const SELLER_INFO = '/seller/info';
export const SELLEROFFICE_API_BASE_URL = '/sellerofficeapi/rest';
export const HIERARCHY_CATEGORIES = '/category-query/categories/hierarchy';
export const GROUPS_CATEGORIES = '/category-query/categories/groups';
export const CHILD_CATEGORIES_BY_PARENT_ID =
  '/category-query/categories/{id}/children';
export const CATEGORY_ATTRIBUTES = '/category-query/v2/category/{id}/attribute';
export const CHILD_CATEGORIES_BY_GROUP_NAME =
  '/category-query/categories/groups/{name}/children';
export const TEMPLATE_DOWNLOAD =
  '/seller-product-query/api/v1/templates/product-upload';
export const VALIDATE_UPLOAD = '/product-command/batches/product-{type}/upload';
export const CONFIRM_UPLOAD = '/product-command/batches';
export const CONFIRM_DEAL_UPLOAD = '/bulk-product-deals';
export const FILE_DOWNLOAD = '/api/product-command/batches/{id}/file';
export const REJECTED_REPORT_DOWNLOAD =
  '/api/product-command/batches/{id}/report';
export const HISTORY_TAB_UPLOAD_URL = '/product-command/batches/upload-history';
export const HISTORY_TAB_DOWNLOAD_URL =
  '/seller-product-query/api/v1/export-product-job';
export const REJECTED_REASONS =
  '/product-command/batches/tasks/{taskId}/details';
export const BULK_DELETE_TEMPLATE =
  'seller-product-query/api/v1/templates/product-delete';
export const BULK_SHIPMENT_TEMPLATE_UPDATE =
  '/seller-product-query/api/v1/templates/shipment-template-update';
export const BULK_STOCK_PRICE_TEMPLATE_UPDATE =
  '/seller-product-query/api/v1/templates/stock-price-update';
export const BULK_STOCK_CODE_TEMPLATE_UPDATE =
  '/seller-product-query/api/v1/templates/stock-code-update';
export const BULK_PRODUCT_TEMPLATE_UPDATE =
  '/seller-product-query/api/v1/templates/product-update';
export const DEAL_TEMPLATE_DOWNLOAD_HISTORY = '/bulk-product-deals/template';
export const DEAL_UPLOAD_HISTORY = '/bulk-product-deals';
export const DEAL_TEMPLATE_CREATE = '/bulk-product-deals/template';
export const DEAL_CREATED_TEMPLATE_DOWNLOAD =
  '/sellerofficeapi/rest/bulk-product-deals/template';
export const DEAL_TEMPLATE_DOWNLOAD =
  '/sellerofficeapi/rest/bulk-product-deals';
export const EXCHANGE_RATES = '/exchange-rates';
export const DELIVERY_DETAIL = '/delivery/detail';
export const BULK_PRODUCT_SAFETY_TEMPLATE =
  '/seller-product-query/api/v1/templates/product-safety-update';
export const BULK_PRODUCT_NUTRITIONAL_TEMPLATE =
  '/seller-product-query/api/v1/templates/product-nutritional-update';
export const BULK_PRODUCT_SAFETY_INFO_UPDATE =
  '/seller-product-query/api/v1/templates/product-safety-info-update';
export const DASHBOARD_INVOICE = 'order/invoice-summary';
export const EARLY_SETTLEMENT_SUMMARY = 'early-settlement/summary';
export const EARLY_SETTLEMENT_CALCULATE = 'early-settlement/calculate';
export const EARLY_SETTLEMENT_HISTORY = 'early-settlement/history';
export const EARLY_SETTLEMENT_REQUEST = 'early-settlement/request';
export const EARLY_SETTLEMENT_CONTRACT = 'early-settlement/contract';
export const EARLY_SETTLEMENT_AVAILABILITY = 'early-settlement/availability';
export const NOTIFICATION_QUERY = '/notification-query';
export const CATALOG_PREPARING_TIME = '/product/preparing-time';
export const STOCK_CODE_VALIDATIONS =
  '/seller-product-query/api/v1/product/internal/check-stock-code';
export const ATTRIBUTE_VALUE_SEARCH =
  '/category-query/v2/attribute-value-search?attributeId={attributeId}&categoryId={categoryId}&value={value}';
export const SUBMIT_DETAIL_DESCRIPTION = '/products/{productId}/description';
export const SUBMIT_SHIPMENT_TEMPLATE = '/products/{productId}/shipment';
export const SUBMIT_SALE_VARIANT_INFO = '/products/update/sale-variant-info';

export const PREPARING_TIME_VALIDATE =
  'product/preparing-time/{preparationTime}/{categoryId}';
export const STOCK_CODE_VALIDATE =
  '/seller-product-query/api/v1/product/internal/check-stock-code?stockCode={stockCode}';
export const GET_PRODUCTS =
  '/seller-product-query/api/v1/product/internal/search?tab={tabParam}';
export const GET_PRODUCTS_BY_SAME_MODELCODE =
  '/seller-product-query/api/v1/product/{productId}/seller-variants?modelCode={modelCode}&categoryId={categoryId}';
export const GET_PRODUCTS_VARIANTS =
  '/seller-product-query/api/v1/product/{productId}/variants';
export const CATEGORY_PRICE_LIMIT =
  'product/category-price-limit/{categoryId}/{price}';
export const PRODUCT_IMAGE_UPLOAD = '/product/images';
export const SUBMIT_SINGLE_PRODUCT = '/product';
export const PRODUCT_DESCRIPTION = '/product/description';
export const PRODUCT_NUTRITIONS =
  '/seller-product/api/v1/lookup-code/product-nutrition-category/{categoryId}';
export const MANUFACTURER_ORIGIN_INFO =
  '/seller-product/api/v1/lookup-code/by-table/countries';
export const SAFETY_INFO = '/seller-product/api/v1/safety-info/{productId}';
export const SAFETY_INFO_UPLOAD = '/seller-product/api/v1/safety-info/files';
export const PRODUCT_NUTRITION_OPTIONS =
  '/seller-product/api/v1/lookup-code/by-tables';
export const PRODUCT_DETAIL = 'seller-product-query/api/v1/product';
export const PRODUCT_SAFETY_INFO = '/seller-product/api/v1/safety-info';
export const PRODUCT_SAFETY_INFO_POST = '/products/{productId}/safety-info';
export const PRODUCT_UPDATE_HISTORY =
  '/seller-product-query/api/v1/catalog-product/seller-feedbacks';
export const PRODUCT_MODEL_CODE_POST = '/products/{productId}/model-code';
export const FEEDBACK_SUGGESTIONS_DESCRIPTION =
  '/feedback-suggestions/description';
export const PRODUCT_FEEDBACK_SUGGESTIONS = '/feedback-suggestions/{type}';
export const PRODUCT_FEEDBACK_SUGGESTIONS_TITLE = '/feedback-suggestions/title';
export const PRODUCT_FEEDBACK_SUGGESTIONS_ATTRIBUTES =
  '/feedback-suggestions/attribute-value';
export const UPDATE_ALL_PRODUCT_FIELDS = '/products/{productId}';
export const CATEGORY_COMMISSION_CAMPAIGNS_COUNTS =
  '/seller-commission-campaigns/count';
export const CATEGORY_COMMISSION_CAMPAIGNS_AVAILABLE =
  '/seller-commission-campaigns/available';
export const CATEGORY_COMMISSION_CAMPAIGNS_JOINED =
  '/seller-commission-campaigns/joined';
export const CATEGORY_COMMISSION_CAMPAIGN_DETAIL =
  '/seller-commission-campaigns';
export const CATEGORY_COMMISSION_CAMPAIGN_JOIN =
  '/seller-commission-campaigns/{campaignId}/join';
export const CATEGORY_COMMISSION_CAMPAIGNS_FILTER_CATEGORIES =
  '/seller-commission-campaigns/filter-categories';
export const SELLER_COMMISSION_CAMPAIGN_DETAIL =
  '/seller-commission-campaigns/{campaignId}';
export const CATEGORY_COMMISSION_CAMPAIGNS_JOIN_BY_PROMO_CODE =
  '/seller-commission-campaigns/join-by-promo-code';
export const CATEGORY_COMMISSION_CAMPAIGN_PROMO_CODE_DETAIL =
  '/seller-commission-campaigns/promo-code-detail/{promoCode}';
export const CATEGORY_COMMISSION_CAMPAIGN_UNSEEN_POPUP = 
  '/seller-commission-campaigns/popup';
export const CATEGORY_COMMISSION_CAMPAIGN_MARK_AS_SEEN =
  '/seller-commission-campaigns/{campaignId}/popup-seen';
export const WMS_AGREEMENT_STATUS = '/wms/seller/agreement/status';
export const WMS_AGREEMENT_ACCEPT = '/wms/seller/agreement/accept';
export const SATURDAY_SHIPMENT_POPUP = 'notice/saturday-shipment/popup';
export const SATURDAY_SHIPMENT_SAVE = 'notice/saturday-shipment';
